<template>
    <div>
        <v-navigation-drawer :mini-variant.sync="showDrawer"
                             :clipped="$vuetify.breakpoint.lgAndUp"
                             permanent
                             app>
            <v-list dense class="menu">
                <template v-for="(item, i) in getFiltered">
                    <v-row v-if="item.heading" :key="item.heading" align="center">
                        <v-col cols="6">
                            <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
                        </v-col>
                        <v-col cols="6" class="text-center">
                            <a href="#!" class="body-2 black--text">EDIT</a>
                        </v-col>
                    </v-row>
                    <v-list-group v-else-if="item.children"
                                  :key="item.text"
                                  v-model="item.model"
                                  :prepend-icon="item.icon">
                        <template v-slot:activator>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <v-list-item v-for="(child, i) in item.children" :key="i" link router :to="child.href" v-on="child.event ? { 'click': child.event } : {}">
                            <v-list-item-action v-if="child.icon">
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ child.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item v-else :key="item.text" link router :to="item.href" v-on="item.event ? { 'click': item.event } : {}">
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title :key="i">{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
            <template v-slot:append>
                
                <div class="pa-2">
                    <v-btn block @click="logout">
                        <v-icon>mdi-logout-variant</v-icon> {{showDrawer ? '' : 'Salir'}}
                    </v-btn>
                </div>
            </template>

        </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        props: ['showDrawer'],
        data() {
            return {
                source: null,
                items: [
                    { icon: "mdi-home-variant", text: "Inicio", href: '/' },
                    { icon: "mdi-map-search-outline", text: "Mapa de Instalaciones", href: '/mapa' },
                    { icon: "mdi-air-filter", text: "Instalaciones", href: '/instalaciones' },
                    { icon: "mdi-chart-areaspline", text: "Gr\u00E1ficas", href: '/graficos' },
                    { icon: "mdi-history", text: "Datos Hist\u00F3ricos", href: '/historicos' },
                    { icon: "mdi-file-document", text: "Informes", href: '/Informes' },
                    this.$auth.check('ADM') ? {
                        icon: "mdi-animation-outline", text: "Mantenimiento", children: [
                            { icon: "mdi-alpha-e-circle-outline", text: "Empresas", href: '/empresas' },
                            { icon: "mdi-alpha-r-box", text: "Tipo Relac. Empresa Instalacion", href: '/tiposrelacionempresainstalacion' },
                            { icon: "mdi-alpha-s-circle-outline", text: "Supervisores", href: '/supervisores' },
                            { icon: "mdi-alpha-v-box", text: "Versiones Supervisores", href: '/VersionesSupervisores' },
                            { icon: "mdi-alpha-c-box", text: "Tipos de Supervisores", href: '/tipossupervisores' },
                            { icon: "mdi-alpha-l-circle-outline", text: "Elementos", href: '/elementos' },
                            { icon: "mdi-alpha-c-box", text: "Tipos de Elementos", href: '/claseelemntos' },
                            { icon: "mdi-alpha-a-box", text: "Agrupaciones Elementos", href: '/agrupacioneselementos' },
                            { icon: "mdi-alpha-v-circle-outline", text: "Variables", href: '/variables' },
                            { icon: "mdi-alpha-c-box", text: "Tipos de Variables", href: '/clasevariables' },
                            { icon: "mdi-alpha-a-box", text: "Agrupaciones Variables", href: '/agrupacionesvariables' },
                            { icon: "mdi-alpha-o-box", text: "Tipos de Variables OMRON", href: '/tiposvariablesomron' },
                            { icon: "mdi-alpha-o-box", text: "Tipos Agrupacion Elementos", href: '/tiposagrupacionelementos' },
                            { icon: "mdi-alpha-i-circle-outline", text: "Imagenes", href: '/imagenes' },
                            { icon: "mdi-alpha-p-box", text: "Permisos", href: '/permisos' },

                        ]
                    } : null,
                    this.$auth.check('ADM') ? { icon: "mdi-account-multiple", text: "Usuarios", href: '/Usuarios' } : null
                ]
            }
        }, methods: {
            logout: function () {
                this.$auth.logout({
                    makeRequest: false
                });
            }
        },
        computed: {
            getFiltered() {
                return this.items.filter(x => x != null);
            }
        }
    }
</script>